module.exports = __webpack_public_path__ + "static/media/image 19.04a8c609.png";